/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfitempty2Inputs */

const en_coverfitempty2 = /** @type {(inputs: Coverfitempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your adjusted cover appears here.`)
};

const de_coverfitempty2 = /** @type {(inputs: Coverfitempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier erscheint dein angepasstes Titelbild.`)
};

/**
* | output |
* | --- |
* | "Your adjusted cover appears here." |
*
* @param {Coverfitempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfitempty2 = /** @type {((inputs?: Coverfitempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfitempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfitempty2(inputs)
	return de_coverfitempty2(inputs)
});
export { coverfitempty2 as "coverFitEmpty" }